// src/shadowGrove/world/locations.js

export const LIBERI_LOCATIONS = {
    portal: {
        name: "The Portal",
        description:
            "The passage from the ordinary world into Liberi Curiosi.",
    },

    forest: {
        name: "The Sylvan Wilds",
        description:
            "A moonlit forest of glowing mushrooms, fireflies, ancient trees, and hidden Genii.",
    },

    academy: {
        name: "The Academy",
        description:
            "The place where curiosity becomes wisdom and scholars begin their studies.",
    },

    classroom: {
        name: "Schola Minervae",
        description:
            "The learning hall inspired by wisdom, strategy, and discovery.",
    },

    rewardShop: {
        name: "Taberna Vastae",
        description:
            "A vast marketplace of earned rewards, treasures, and curiosities.",
    },

    library: {
        name: "Bibliotheca",
        description:
            "The library of records, lessons, books, and discoveries.",
    },
};